import './SellWithUs.css';
import SellForm from './SellForm/SellForm';
import SellHowWorks from './SellHowWorks/SellHowWorks';
import SellHeading from './SellHeading/SellHeading';
import SellBenefits from './SellBenefits/SellBenefits';
import Testimonials from './Testimonials/Testimonials';
import GoToFaq from './GoToFaq/GoToFaq';

function SellWithUs() {
  return (
    <div className="sell-with-us">
      <SellHeading />
      <div className="sell-with-us__container">
        <SellBenefits />
        <SellHowWorks />
        <SellForm />
        <Testimonials title='Отзывы' />
        {/* <div className="sell-with-us__block">

          <GoToFaq />
        </div> */}
      </div>
    </div>
  );
}

export default SellWithUs;
